const actionScope = '[Logout]';

export class LogOut {
  static readonly type = `${actionScope} Log Out`;

  constructor(public refreshToken: string) {}
}

export class LogOutCompleted {
  static readonly type = `${actionScope} Log Out Completed`;
}

export class LogOutError {
  static readonly type = `${actionScope} Log Out Error`;
}
